








































































































































import { Component, Vue } from "vue-property-decorator";
import Tab from "@/components/Tab.vue";
import DockItem from "@/components/DockItem.vue";
import BookmarkButton from "@/components/BookmarkButton.vue";
import BrowserButton from "@/components/BrowserButton.vue";
import ActionButton from "@/components/ActionButton.vue";
import BrowserButtonType from "@/enums/BrowserButtonType";
import TabParams from "@/models/TabParams";
import BrowserPosition from "@/models/BrowserPosition";
import MousePosition from "@/models/CursorPosition";

const backgroundImage = require("@/assets/background.jpg");

const MOBILE_WIDTH = 480;

const BROWSER_HEADER_HEIGHT = 112;

const MIN_BROWSER_WIDTH = 400;
const MIN_BROWSER_HEIGHT = 200;

@Component({
  components: {
    Tab,
    DockItem,
    BookmarkButton,
    BrowserButton,
    ActionButton
  },
  data: () => {
    return {
      BrowserButtonType,
      backgroundImage,
      BROWSER_HEADER_HEIGHT
    };
  }
})
export default class App extends Vue {
  private browserSize: { width: number; height: number } = {
    width: 1000,
    height: 612
  };
  private startBrowserSize: { width: number; height: number } = {
    width: 0,
    height: 0
  };
  private browserPosition: BrowserPosition = { top: 0, left: 0 };
  private cursorPosition: MousePosition = { x: 0, y: 0 };
  private cursorStartPosition: MousePosition = { x: 0, y: 0 };

  private transition: number = 0.4;
  private selectedTabPath: string | null = null;
  private deletedTabs: string[] = [];
  private urlInputValue: string | null = null;

  private isMobile: boolean = false;
  private isFullsize: boolean = false;
  private isShow: boolean = true;
  private isPut: boolean = false;
  private readonly tabs: TabParams[] = [
    { path: "/", name: "Home" },
    { path: "/skills", name: "Skills" },
    { path: "/works", name: "Works" }
  ];

  public mounted() {
    if (window.location.pathname) {
      this.selectedTabPath = window.location.pathname;
      this.urlInputValue = "localhost:3000" + window.location.pathname;
    }
    const windowWidth = window.innerWidth;
    const left = (windowWidth - this.browserSize.width) / 2;

    this.isMobile = window.parent.screen.width < 480;
    this.browserPosition = { top: 50, left: left > 0 ? left : 50 };
  }

  private initializeCursor(e: MouseEvent) {
    this.cursorPosition = {
      x: e.pageX,
      y: e.pageY
    };
  }

  private handleMouseDownResizer(e: MouseEvent) {
    if (this.isFullsize) {
      return null;
    }
    this.initializeCursor(e);
    this.startBrowserSize = {
      width: this.browserSize.width,
      height: this.browserSize.height
    };
    this.transition = 0;

    document.addEventListener(
      "mousemove",
      this.handleMouseMoveForResizingWindow,
      false
    );
    document.addEventListener(
      "mouseup",
      this.handleMouseUpForResizingWindow,
      false
    );
  }

  private handleMouseMoveForResizingWindow: EventListenerObject = {
    handleEvent: (event: MouseEvent) => this.mouseMoveForResizingWindow(event)
  };

  private handleMouseUpForResizingWindow: EventListenerObject = {
    handleEvent: () => this.mouseUpForResizingWindow()
  };

  private mouseMoveForResizingWindow(e: MouseEvent) {
    const height =
      this.startBrowserSize.height + e.pageY - this.cursorPosition.y;
    const width = this.startBrowserSize.width + e.pageX - this.cursorPosition.x;
    if (width >= MIN_BROWSER_WIDTH) {
      this.browserSize = Object.assign({}, this.browserSize, { width });
    } 
    if (height >= MIN_BROWSER_HEIGHT) {
      this.browserSize = Object.assign({}, this.browserSize, { height });
    }
  }

  private mouseUpForResizingWindow() {
    this.startBrowserSize = { width: 0, height: 0 };
    this.transition = 0.3;
    document.removeEventListener(
      "mousemove",
      this.handleMouseMoveForResizingWindow,
      false
    );
    document.removeEventListener(
      "mouseup",
      this.handleMouseUpForResizingWindow,
      false
    );
  }

  private handleMouseDownBrowserNav(e: MouseEvent) {
    if (this.isFullsize) {
      return null;
    }
    this.initializeCursor(e);
    this.cursorStartPosition = {
      x: this.browserPosition.left,
      y: this.browserPosition.top
    };
    this.transition = 0;

    document.addEventListener(
      "mousemove",
      this.handleMouseMoveForMovingWindow,
      false
    );
    document.addEventListener(
      "mouseup",
      this.handleMouseUpForMovingWindow,
      false
    );
  }

  private handleMouseMoveForMovingWindow: EventListenerObject = {
    handleEvent: (event: MouseEvent) => this.mouseMoveForMovingWindow(event)
  };

  private handleMouseUpForMovingWindow: EventListenerObject = {
    handleEvent: () => this.mouseUpForMovingWindow()
  };

  private mouseMoveForMovingWindow(e: MouseEvent) {
    const top = this.cursorStartPosition.y + e.pageY - this.cursorPosition.y;
    const left = this.cursorStartPosition.x + e.pageX - this.cursorPosition.x;
    this.browserPosition = { top, left };
  }

  private mouseUpForMovingWindow() {
    this.cursorStartPosition = { x: 0, y: 0 };
    this.transition = 0.3;
    document.removeEventListener(
      "mousemove",
      this.handleMouseMoveForMovingWindow,
      false
    );
    document.removeEventListener(
      "mouseup",
      this.handleMouseUpForMovingWindow,
      false
    );
  }

  private handleClickCloseButton() {
    this.isShow = false;
    this.isFullsize = false;
  }

  private handleClickChromeIcon() {
    this.isShow = true;
  }

  private handleClickPutButton() {
    this.isPut = true;
  }

  private handleClickBrowserIcon() {
    this.isPut = false;
  }

  private handleClickFullsizeButton() {
    this.isFullsize = !this.isFullsize;
  }

  private handleClickDeleteTab(tabPath: string) {
    this.deletedTabs.push(tabPath);
  }

  private handleClickTab(tabPath: string) {
    this.selectedTabPath = tabPath;
    this.urlInputValue = "localhost:3000" + tabPath;
    this.$router.push(tabPath);
  }

  private handleClickPrevButton() {
    this.$router.go(-1);
  }

  private handleClickNextButton() {
    this.$router.go(1);
  }

  private handleClickReloadButton() {
    window.location.reload();
  }

  private handleKeyDown(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      window.open(`https://www.google.co.jp/search?q=${this.urlInputValue}`);
    }
  }
}
